import { NgModule, ModuleWithProviders } from '@angular/core';

import { SN_GOOGLE_MAP_LIBRARY, GoogleMapLibrary } from '@lib/geo/google/core';

@NgModule()
export class GooglePlacesModule {
  public static forRoot(): ModuleWithProviders<GooglePlacesModule> {
    return {
      ngModule: GooglePlacesModule,
      providers: [
        {
          provide: SN_GOOGLE_MAP_LIBRARY,
          useValue: GoogleMapLibrary.Places,
          multi: true,
        },
      ],
    };
  }
}
